import styled from "styled-components";

export const ActionContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  @media screen and (width < 320px) {
    justify-content: center;
  }
`;
// TODO:make this into a reusable component and remove other instances of it being duplicated
interface IActionBtnContainerProps {
  responsiveW?: boolean;
  addMargin?: boolean;
}
export const ActionBtnContainer = styled.div<IActionBtnContainerProps>`
  display: flex;
  min-width: 220px;
  min-width: ${(props) => (props.responsiveW ? "0" : "220px")};
  margin: ${(props) => (props.addMargin ? "0 10px" : "0")};
  justify-content: space-between;
  @media screen and (max-width: 425px) {
    justify-content: space-between;
    width: 100%;
  }
  @media screen and (width < 320px) {
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }
`;
// styles for the buttons
// button interface
interface IBtnProps {
  white_color?: boolean;
  purpleBg?: boolean;
  purple_border?: boolean;
  width?: string;
  marginRight?: boolean;
  lightMedium?: boolean;
  smallWidth?: string;
  largeWidth?: string;
  bgColor?: string;
  color?: string;
  height?: string;
  margin?: string;
  longText?: boolean;
  borderStyle?: string;
  borderRadius?: string;
  testId?: string;
}
// styles for general button

export const ActionBtnU = styled.button.attrs({
  className: "rounded text-sm ",
})<IBtnProps>`
  /* set dynamic margins */
  margin: ${(props) => props.margin ?? "0"};

  /* set dynamic height */
  height: ${(props) => props.height ?? "40px"};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => props.disabled && "0.65"};
  color: ${(props) =>
    props.white_color ? "white" : "var(--primaryPurpleMain)"};
  color: ${(props) => props.lightMedium && "var(--lightMedium)"};
  color: ${(props: any) =>
    props.color
      ? props.color
      : props.white_color
        ? props.white_color
        : props.lightMedium
          ? props.lightMedium
          : "var(--primaryPurpleMain)"};
  background-color: ${(props: any) =>
    props.purpleBg
      ? "var(--primaryPurpleMain)"
      : props.redBg
        ? "red"
        : "white"};

  /* border: ${(props: any) =>
    props.purple_border ? "1px solid var(--primaryPurpleMain)" : "none"}; */
  border: ${(props: any) =>
    props.borderStyle
      ? props.borderStyle
      : props.purple_border
        ? "1px solid var(--primaryPurpleMain)"
        : "none"};
  @media screen and (min-width: 426px) {
    margin-right: ${(props: any) => (props.marginRight ? "15px" : "0")};
  }

  width: 94px;
  width: ${(props: any) => props.largeWidth ?? "94px"};

  @media screen and (max-width: 435px) {
    /* width: 100%; */
    width: 90px;
    /* width: ${(props: any) => props.smallWidth ?? "35%"}; */
  }
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 320px) {
    width: 30%;
  }
  @media screen and (width < 320px) {
    width: 100%;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  border-radius: ${(props) =>
    props.borderRadius ? props.borderRadius : "4px"} !important;
`;
